<div class="float-right" style="padding-right: 1em;">
  <ng-container *ngIf="published;else unpublished">
      <i class="fa fa-check-circle" style="color: rgb(0, 172, 24);" i18n-tooltip="@@Published.Tooltip" tooltip="Published.Tooltip" placement="left"></i>
  </ng-container>
  <ng-template #unpublished>
      <i class="fa fa-ban" style="color: grey;" i18n-tooltip="@@Published.Tooltip" tooltip="Published.Tooltip" placement="left"></i>
  </ng-template>
</div>
